export const GET_ERRORS = "GET_ERRORS";
export const GET_MESSAGES = "GET_MESSAGES";
export const CREATE_MESSAGE = "CREATE_MESSAGE";

export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const UPDATE_USER = "UPDATE_USER";
export const AUTH_ERROR = "AUTH_ERROR";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAIL = "LOGOUT_FAIL";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";

export const GET_PRODUCT_LIST = "GET_PRODUCT_LIST";
export const GET_VARIETY = "GET_VARIETY";

export const GET_PRODUCE = "GET_PRODUCE";
export const GET_ALL_PRODUCE = "GET_ALL_PRODUCE";
export const CREATE_PRODUCE = "CREATE_PRODUCE";
export const UPDATE_PRODUCE = "UPDATE_PRODUCE";
export const DELETE_PRODUCE = "DELETE_PRODUCE";

export const GET_BIDS_LIST = "GET_BIDS_LIST";
export const CREATE_BID = "CREATE_BID";
export const ACCEPT_BID = "ACCEPT_BID";
export const DELETE_BID = "DELETE_BID";

export const GET_FARM = "GET_FARM";
export const GET_FARM_DETAIL = "GET_FARM_DETAIL";
export const CREATE_FARM = "CREATE_FARM";
export const UPDATE_FARM = "UPDATE_FARM";

export const GET_PRODUCT_STATS = "GET_PRODUCT_STATS";
